import { gql } from "@apollo/client";

export const POPULATE_DATA_FROM_3SHAPE = gql`
  mutation PopulateDataFrom3Shape($orderId: String!) {
    populateDataFrom3shapeCommunicate(orderId: $orderId) {
      id
    }
  }
`;

export const POPULATE_DATA_FROM_MEDITLINK = gql`
  mutation PopulateDataFromMeditLink($orderId: String!) {
    populateDataFromMeditLink(orderId: $orderId) {
      id
    }
  }
`;

export const GET_DELIVERY_PROOF = gql`
  mutation GetDeliveryProof($orderId: String!) {
    getDeliveryProof(orderId: $orderId)
  }
`;

export const GET_ORDER_DELIVERY_INFO = gql`
  query GetOrderDeliveryInfo($orderId: String!) {
    getOrderDeliveryInfo(orderId: $orderId) {
      date
      eventDescription
      eventType
    }
  }
`;

export const UPDATE_DELIVERY_DATE = gql`
  mutation UpdateOrderDeliveryDate(
    $orderId: String!
    $newDeliveryDate: Timestamp!
    $shouldUpdateAbutmentType: Boolean!
  ) {
    updateOrderDeliveryDate(
      orderId: $orderId
      newDeliveryDate: $newDeliveryDate
      shouldUpdateAbutmentType: $shouldUpdateAbutmentType
    ) {
      id
    }
  }
`;

export const UPDATE_MANY_ORDER = gql`
  mutation updateManyOrder(
    $data: OrderUpdateManyMutationInput!
    $where: OrderWhereInput!
  ) {
    updateManyOrder(data: $data, where: $where)
  }
`;

export const UPDATE_ORDER = gql`
  mutation updateOrder(
    $data: OrderUpdateInput!
    $where: OrderWhereUniqueInput!
  ) {
    updateOrder(data: $data, where: $where) {
      id
    }
  }
`;

export const REDO_ORDER = gql`
  mutation RedoOrder(
    $orderId: String!
    $comment: String!
    $clinicClosingTime: String
    $packageReadyTime: String
    $scheduledDate: String
  ) {
    redoOrder(
      orderId: $orderId
      comment: $comment
      clinicClosingTime: $clinicClosingTime
      packageReadyTime: $packageReadyTime
      scheduledDate: $scheduledDate
    ) {
      file
      newDeliveryDate
    }
  }
`;

export const TRANSLATE_COMMENT = gql`
  mutation TranslateComment(
    $data: OrderCommentUpdateInput!
    $where: OrderCommentWhereUniqueInput!
  ) {
    translateComment(data: $data, where: $where)
  }
`;

export const GET_ORDER_BY_UNIQUE_ATTRIBUTE = gql`
  query GetOrderByUniqueAttribute($where: OrderWhereUniqueInput!) {
    getOrderByUniqueAttribute(where: $where) {
      id
      orderReference
      comment
      deliveryDate
      status
      createdAt
      updatedAt
      directId
      userId
      addressId
      patientId
      isArchived
      lastShippingDate
      internalComments
      providerGroupId
      isRush
      isMailSent
      isPhysicalPrint
      createdWithWebapp
      confirmedAt
      integrationType
      redo {
        id
      }
      pickup {
        id
        createdAt
        status
        scheduledDate
        closingTime
        comment
        shipping {
          trackingNumber
        }
      }
      provider {
        id
        name
      }
      shippedBackToProviderDate
      history {
        status
        action
        details
        createdAt
        user {
          firstName
          lastName
        }
      }
      patient {
        id
        directId
        dentistId
        firstName
        lastName
        birthdate
        sex
        createdAt
        updatedAt
      }
      shippings {
        shipping {
          trackingNumber
          shippingType
        }
      }
      address {
        id
        userId
        name
        recipient
        streetNumber
        streetName
        city
        postcode
        country
        isMain
        createdAt
        updatedAt
      }
      files {
        id
        fileType
        key
        read
        createdAt
      }
      user {
        id
        lastName
        firstName
        email
        phoneNumber
        type
        role
        userReference
        createdAt
        updatedAt
        userGroupId
        clientBillingId
        directConnectName
        directConnectPath
        usernameComputer
        macAddressComputer
        isManager
        allowPhysicalPrint
        userGroup {
          id
          clinicNumber
          deliveryCarrier
          pickupCarrier
          description
          phoneNumber
          availableProvider {
            provider {
              id
              name
              displayPriority
            }
          }
          addresses {
            id
            streetNumber
            streetName
            postcode
            city
            details
            country
          }
        }
      }
      orderComment {
        id
        translatedComment
        comment
        type
        read
        createdAt
        files {
          id
          fileType
          key
          read
        }
      }
      products {
        id
        orderId
        productType
        teeth
        itemPreferences
        hasIndividualItemCaracteristics
        createdAt
        createdBy {
          id
          firstName
          type
        }
        implantItem {
          id
          itemType
          teeth
          itemMaterial {
            id
            label
          }
          itemShade {
            id
            label
          }
          itemBilling {
            firstMaterialLotNumber
            firstMaterialTraceabilityId
            secondMaterialLotNumber
            id
          }
          abutmentMaterial {
            id
            label
          }
          abutmentType
          implantPlatform
          implantReference {
            brand
            label
            id
            platforms
          }
          retentionType
          scanBodySuggestion
          standardAbutmentSuggestion
          implantReferenceSuggestion
          teethshadeType
          multiShadeInfo {
            id
            teethShadeSide
            itemShade {
              id
              label
              shadeType
            }
          }
        }
        anatomyItem {
          id
          itemType
          teeth
          itemShade {
            id
            label
          }
          itemMaterial {
            id
            label
          }
          inlayCoreHasClavette
          inlayCoreScanPost
          inlayCoreMaterial {
            id
            label
          }
          itemBilling {
            firstMaterialLotNumber
            secondMaterialLotNumber
            firstMaterialTraceabilityId
            id
          }
          teethshadeType
          multiShadeInfo {
            teethShadeSide
            itemShade {
              id
              shadeType
              label
            }
          }
        }
        removableItem {
          id
          itemType
          teeth
          teethToManufacture
          workflowType
          dentistNotes
          isReplacement
          waxUpType
          fullDentureOrderType
          partialDentureOrderType
          imprintType
          rdvNumber
          rdv2Choice
          returnMethod
          itemMaterial {
            id
            label
          }
          teethShade {
            id
            label
          }
          gingivaShade {
            id
            label
          }
          itemBilling {
            firstMaterialLotNumber
            firstMaterialTraceabilityId
            secondMaterialLotNumber
            id
          }
          partialDenture {
            id
            missingTeeth
            hooks {
              id
              hooksMaterial {
                id
                label
              }
              hooksPosition
            }
            palatalMetalBand
            metalMesh
            lingualMetalBand
            customTray
          }
        }
      }
      orderBilling {
        id
        userId
        providerId
        orderId
        status
        type
        totalVat
        discount
        priceExcludingVat
        totalPrice
        createdAt
        updatedAt
      }
      ChatMarkAsUnread {
        id
      }
      shippings {
        shippingId
        createdAt
        shipping {
          trackingNumber
          shippingType
        }
      }
    }
  }
`;

export const GET_ORDER_ESTIMATED_DELIVERY_DATE = gql`
  query GetOrderEstimatedDeliveryDate(
    $orderId: String!
    $useConfirmedAtAsReferenceDate: Boolean
  ) {
    getOrderEstimatedDeliveryDate(
      orderId: $orderId
      useConfirmedAtAsReferenceDate: $useConfirmedAtAsReferenceDate
    ) {
      deliveryDate
      minimalRushDeliveryDate
      bankHolidays {
        beginDate
        endDate
        useCustomDelay
      }
    }
  }
`;

export const REFRESH_PASTILLE = gql`
  mutation RefreshPastille($args: [RefreshPastilleInput!]!) {
    refreshPastille(args: $args)
  }
`;

export const NOTIFY_INTERNAL_PICKUP_REQUIRED = gql`
  mutation NotifyInternalPickupRequired(
    $orderId: String!
    $createPickup: Boolean
    $dentistDidNotDownload: Boolean
  ) {
    notifyInternalPickupRequired(
      orderId: $orderId
      createPickup: $createPickup
      dentistDidNotDownload: $dentistDidNotDownload
    )
  }
`;

export const GENERATE_LABORATORY_ORDER_DOCUMENT = gql`
  mutation GenerateLaboratoryOrderDocument($orderId: String!) {
    generateLaboratoryOrderDocument(orderId: $orderId)
  }
`;
